/* 🤖 this file was generated by svg-to-ts */
export const kzIconsLaptop: {
  name: 'laptop';
  data: string;
} = {
  name: 'laptop',
  data: `<svg viewBox="0 0 20.1 16.3" xml:space="preserve" fill="currentColor"><path d="M10.8 13H9.3c-1 0-1.7-.8-1.7-1.7v-.1c0-.4.3-.8.8-.8h3.5c.4 0 .8.3.8.8v.1c-.1 1-.9 1.7-1.9 1.7z"/><path d="M1.9 12c-.4 0-.7-.3-.8-.7L1 1.5c0-.3.1-.7.4-.9.2-.3.6-.4.9-.4L17.7 0c.7 0 1.3.6 1.3 1.3l.1 9.8c0 .2-.1.4-.2.5s-.3.2-.5.2L1.9 12zm.6-10.3.1 8.8 15.1-.1-.1-8.9-15.1.2zm0-.2z"/><path d="M2.3 16.3c-1.2 0-2.2-1-2.3-2.2v-2.8c0-.2.1-.4.2-.5.1-.1.3-.2.5-.2l18.6-.2c.4 0 .7.3.8.7l.1 2.7c0 .6-.2 1.2-.6 1.6s-1 .7-1.6.7l-15.7.2c.1 0 0 0 0 0zM1.5 12l.1 2.1c0 .4.3.8.8.7l15.5-.1c.4 0 .8-.4.8-.8v-2L1.5 12z"/></svg>`
};
